
import { defineComponent } from 'vue';
import { mergeColorClass } from '@/scss/StyleClassManager';
import { BlockItemContent } from '@/models/Blocks/Itens/Types/block-content-types';

export default defineComponent({
    props:{
        content:{
            type: Object as () => BlockItemContent,
            default: () => { return {}}
        },
        className:{
            type: [Object, String],
            default: () => {}
        }
    },
    data(){
        return {
            contentClass: {},
            contentStyle: ''
        }
    },
    mounted(){
        let mergedClass = this.content.color ? mergeColorClass(this.className, this.content.color) : null;
        if(mergedClass){
            this.contentClass = mergedClass;
        }else{
            this.contentStyle = this.content.color ? 'color: ' + this.content.color : '';
            this.contentClass = this.className;
        }
    }
});
